import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* loadReviewTag() {
  yield takeEvery(actionTypes.LOAD_REVIEW_TAG, function* (action) {
    try {
      const response = yield API.loadReviewTag(action.data);
      if (response.data.success) {
        yield put(actions.loadReviewTagSuccess(response.data.data));
      } else {
        // console.log(
        //   "Warning: Fail to load review tag. \n" + response.data.message
        // );
        yield put(actions.loadRestaurantMenuListFail());
      }
    } catch (error) {
      //   console.log(
      //     "Error: Fail to load review tag. \n" + API.constructErrMsg(action.error)
      //   );
      yield put(actions.loadRestaurantMenuListFail());
    }
  });
}

export function* loadRestaurantReview() {
  yield takeEvery(actionTypes.LOAD_RESTAURANT_REVIEW, function* (action) {
    try {
      const response = yield API.loadRestaurantReview(
        action.restaurantID,
        action.reviewID,
        action.data
      );
      if (response.data.success) {
        yield put(actions.loadRestaurantReviewSuccess(response.data.data));
      } else {
        alert("Warning: Fail to load review. " + response.data.message);
        yield put(actions.loadRestaurantReviewFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load review."));
      yield put(actions.loadRestaurantReviewFail());
    }
  });
}

export function* restaurantLikedReview() {
  yield takeEvery(actionTypes.LIKED_RESTAURANT_REVIEW, function* (action) {
    try {
      const response = yield API.likedRestaurantReview(action.data.reviewID);
      if (response.data.success) {
        let like = "";
        if (action.data.likes_status === 0) {
          like = "Unliked Review Successful";
        } else {
          like = "Liked Review Successful";
        }
        yield put(actions.toastSuccess(like));
      } else {
        alert("Warning: Fail to like product. \n" + response.data.message);
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to like product. \n"));
    }
  });
}

export default function* reviewSaga() {
  yield all([
    fork(loadReviewTag),
    fork(loadRestaurantReview),
    fork(restaurantLikedReview),
  ]);
}
